export type QueryLike<T> = {
  data: T | undefined;
  isLoading: boolean;
  isError?: boolean;
};

export type Ready<T> = {
  data: T;
  isLoading: false;
  isError: false;
};

/** Narrows `q` to a loaded-and-successful result with non-undefined data */
export function isReady<T>(q: QueryLike<T>): q is Ready<T> {
  return !q.isLoading && q.isError === false && q.data !== undefined;
}
